<template>
    <div class="tabcontent">
        <v-container :fluid="true" v-resize="onResize" ref="bddsplanfactcontainer">
            <v-row align="center">
                <v-col cols="12" md="2" sm="3">
                    <v-select
                            v-model="yearbdds"
                            :items="yearfilter"
                            label="Год"
                            @input="changeYearHandle"
                    ></v-select>
                </v-col>
                <!--
                <v-col cols="12" md="2" sm="3">
                  <v-select
                      multiple
                      v-model="monthbdds"
                      :items="monthsFilter"
                      label="Месяц"
                      @input="changeYearHandle"
                  ></v-select>
                </v-col>
                -->
                <v-col cols="12" md="3" sm="6">
                    <v-skeleton-loader
                            :loading="loading"
                            type="list-item"
                            class="mx-auto"
                    >
                        <v-select
                                v-model="IdOrg"
                                :items="orglist"
                                label="Организация"
                                @input="changeOrg"
                        ></v-select>
                    </v-skeleton-loader>
                </v-col>
                <v-col cols="12" md="3" sm="6">
                    <v-skeleton-loader
                            :loading="loading"
                            type="list-item"
                            class="mx-auto"
                    >
                        <v-select
                                v-model="IdHouse"
                                :items="houselist"
                                label="Объект"
                                @input="changeHouse"
                        ></v-select>
                    </v-skeleton-loader>
                </v-col>
                <v-col class="rightExPd" cols="12" md="2" sm="3">
                    <v-btn color="primary" @click="updateClick()">
                        <v-icon>mdi-reload</v-icon>
                    </v-btn>
                    <v-btn color="primary" @click="excelPFList" dark>
                      <v-icon>mdi-microsoft-excel</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
        <v-skeleton-loader
                :loading="loading"
                type="table-tbody"
                class="mx-auto"
        >
        <v-card>
            <v-simple-table>
                <template>
                    <thead>
                    <tr>
                        <th class="stick" style="min-width: 280px;">Статья оборота</th>
                        <th v-for="month in months" :key="month" style="min-width: 160px;" colspan="2">
                            {{ month }}
                        </th>
                    </tr>
                    <tr>
                        <th class="stick"></th>
                        <template  v-for="month in months">
                            <th :key="month+'P'" style="min-width: 80px;">План</th>
                            <th :key="month+'F'" style="min-width: 80px;">Факт</th>
                        </template>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td class="stick">Сальдо на начало</td>
                        <template v-for="item in bddsBegOst">
                            <td :key="item.ID+'P'" class="text-right">{{item.ValPlan | toCurrency}}</td>
                            <td :key="item.ID+'F'" class="text-right">{{item.ValFact | toCurrency}}</td>
                        </template>
                    </tr>
                    <tr>
                        <td class="stick">
                          <v-btn icon color="default darken-1" @click="clickShow('in')" v-show="bddsIn.length>0">
                            <v-icon class="mdi-18px">{{iconExpand('in')}}</v-icon>
                          </v-btn>
                          <span class="font-weight-black">Поступления</span>
                        </td>
                        <template v-for="SummIn in In">
                          <td :key="SummIn.ID+'P'" class="text-right">{{SummIn.ValPlan | toCurrency}}</td>
                          <td :key="SummIn.ID+'F'" class="text-right">{{SummIn.ValFact | toCurrency}}</td>
                        </template>
                    </tr>

                    <template v-for="(group, indexgr) in bddsIn">
                        <tr :key="'g'+group.ID" v-if="group.ID > 0" v-show="ShowId('in')">
                            <td class="stick">
                                <v-btn icon color="default darken-1" @click="clickShow(group.ID)" v-show="group.sub.length>0">
                                  <v-icon class="mdi-18px">{{iconExpand(group.ID)}}</v-icon>
                                </v-btn>
                                <span class="font-weight-bold">{{ group.Numb>0 ? group.Numb : parseInt(indexgr) + 1 }} {{ group.Name }}</span>
                            </td>
                            <template v-for="SummGroup in group.Sums">
                              <td :key="SummGroup.ID+'P'" class="text-right">{{SummGroup.ValPlan | toCurrency}}</td>
                              <td :key="SummGroup.ID+'F'" class="text-right">{{SummGroup.ValFact | toCurrency}}</td>
                            </template>
                        </tr>

                        <template v-for="(item, indexs) in group.sub">
                            <tr :key="'s'+item.ID" v-show="ShowId(group.ID) && ShowId('in')">
                                <td class="stick">
                                  <v-btn icon color="default darken-1" @click="clickShow(item.ID)" v-show="item.sub.length>0">
                                    <v-icon class="mdi-18px">{{iconExpand(item.ID)}}</v-icon>
                                  </v-btn>
                                  <span class="pl-2 font-weight-medium">{{ group.Numb>0 ? group.Numb : parseInt(indexgr) + 1 }}.{{ item.Numb>0 ? item.Numb : indexs + 1 }} {{ item.Name }}</span>
                                </td>
                                <template v-for="Summ in item.Sums">
                                    <td :key="Summ.ID+'P'" class="text-right">{{Summ.ValPlan | toCurrency}}</td>
                                    <td :key="Summ.ID+'F'" class="text-right">{{Summ.ValFact | toCurrency}}</td>
                                </template>
                            </tr>
                          <tr v-for="(subitem, indexsub) in item.sub" :key="'s'+item.ID+'s'+subitem.ID" v-show="ShowId(item.ID) && ShowId(group.ID) && ShowId('in')">
                              <td class="stick"><div class="pl-14">{{ group.Numb>0 ? group.Numb : parseInt(indexgr) + 1 }}.{{ item.Numb>0 ? item.Numb : indexs + 1 }}.{{ subitem.Numb>0 ? subitem.Numb : indexsub + 1 }} {{ subitem.Name }}</div></td>
                              <template v-for="Summsub in subitem.Sums">
                                 <td :key="Summsub.ID+'SP'" class="text-right">{{Summsub.ValPlan | toCurrency}}</td>
                                 <td :key="Summsub.ID+'SF'" class="text-right">{{Summsub.ValFact | toCurrency}}</td>
                             </template>
                       </tr>
                   </template>

                 </template>

                 <tr>
                     <td class="stick">
                       <v-btn icon color="default darken-1" @click="clickShow('out')" v-show="bddsOut.length>0">
                         <v-icon class="mdi-18px">{{iconExpand('out')}}</v-icon>
                       </v-btn>
                       <span class="font-weight-black">Расходы</span>
                     </td>
                     <template v-for="SummOut in Out">
                       <td :key="SummOut.ID+'P'" class="text-right">{{SummOut.ValPlan | toCurrency}}</td>
                       <td :key="SummOut.ID+'F'" class="text-right">{{SummOut.ValFact | toCurrency}}</td>
                     </template>
                 </tr>
                 <template v-for="(group, indexgr) in bddsOut">
                     <tr :key="'g'+group.ID" v-if="group.ID > 0" v-show="ShowId('out')">
                         <td class="stick">
                             <v-btn icon color="default darken-1" @click="clickShow(group.ID)" v-show="group.sub.length>0">
                               <v-icon class="mdi-18px">{{iconExpand(group.ID)}}</v-icon>
                             </v-btn>
                             <span class="font-weight-bols">{{ group.Numb>0 ? group.Numb : parseInt(indexgr) + 1 }} {{ group.Name }}</span>
                         </td>
                         <template v-for="SummGroup in group.Sums">
                           <td :key="SummGroup.ID+'P'" class="text-right">{{SummGroup.ValPlan | toCurrency}}</td>
                           <td :key="SummGroup.ID+'F'" class="text-right">{{SummGroup.ValFact | toCurrency}}</td>
                         </template>
                     </tr>
                     <template v-for="(item, indexs) in group.sub">
                         <tr :key="'s'+item.ID" v-show="ShowId(group.ID) && ShowId('out')">
                             <td class="stick">
                               <v-btn icon color="default darken-1" @click="clickShow(item.ID)" v-show="item.sub.length>0">
                                 <v-icon class="mdi-18px">{{iconExpand(item.ID)}}</v-icon>
                               </v-btn>
                               <span class="pl-2 font-weight-medium">{{ group.Numb>0 ? group.Numb : parseInt(indexgr) + 1 }}.{{ item.Numb>0 ? item.Numb : indexs + 1 }} {{ item.Name }}</span>
                             </td>
                             <template v-for="Summ in item.Sums">
                                 <td :key="Summ.ID+'P'" class="text-right">{{Summ.ValPlan | toCurrency}}</td>
                                 <td :key="Summ.ID+'F'" class="text-right">{{Summ.ValFact | toCurrency}}</td>
                             </template>
                         </tr>
                         <tr v-for="(subitem, indexsub) in item.sub" :key="'s'+item.ID+'s'+subitem.ID" v-show="ShowId(item.ID) && ShowId(group.ID) && ShowId('out')">
                             <td class="stick"><div class="pl-14">{{ group.Numb>0 ? group.Numb : parseInt(indexgr) + 1 }}.{{ item.Numb>0 ? item.Numb : indexs + 1 }}.{{ subitem.Numb>0 ? subitem.Numb : indexsub + 1 }} {{ subitem.Name }}</div></td>
                             <template v-for="Summsub in subitem.Sums">
                                 <td :key="Summsub.ID+'SP'" class="text-right">{{Summsub.ValPlan | toCurrency}}</td>
                                 <td :key="Summsub.ID+'SF'" class="text-right">{{Summsub.ValFact | toCurrency}}</td>
                             </template>
                         </tr>
                     </template>
                 </template>
                 <tr>
                     <td class="stick">Сальдо на конец</td>
                     <template v-for="item in bddsEndOst">
                         <td :key="item.ID+'P'" :class="'text-right ' + endColor(item.ValPlan)">{{item.ValPlan | toCurrency}}</td>
                         <td :key="item.ID+'F'" :class="'text-right ' + endColor(item.ValFact)">{{item.ValFact | toCurrency}}</td>
                     </template>
                 </tr>
                 </tbody>
             </template>
         </v-simple-table>
     </v-card>
     </v-skeleton-loader>
 </div>
</template>

<script>

 import { bus } from '../../plugins/bus.js';

 export default {
     name: "BddsPlanFact",
     mounted() {
         this.$store.dispatch('GET_ORGFILTERS', {IdOrg: this.IdOrg, IdHouse: this.IdHouse > 0 ? this.IdHouse : -1}).then(() => {
             this.$store.dispatch('GET_BDDSPFLIST', {year: this.yearbdds, month: this.monthbddsGet, IdOrg: this.IdOrg, IdHouse: this.IdHouse}).then(() => {
                 this.loading = false;
             });
         });

         bus.$on('refreshTabBddsFact', this.refreshHandler);
     },
     beforeMount () {
         this.loadFilters();
     },
     data() {
         return {
             loading: true,
             yearbdds: new Date().getFullYear(),
             monthbdds: [],
             monthbddsGet: '',
             monthsFilter: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
             IdOrg: localStorage.getItem('idtsg'),
             IdHouse: '',
             months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
             heightTable: (window.innerHeight - 200),
             expand: [{expand: false, ID: 'in'}],
             expandOut: [{expand: false, ID: 'out'}],
         }
     },
     methods: {
         loadFilters: function() {
             let year = localStorage.getItem('VUE_TABS_BDDSPF_YEAR');
             if (year) {
                 this.IdOrg = JSON.parse(year);
             }
             /*let month = localStorage.getItem('VUE_TABS_BDDSPF_MONTH');
             if (month) {
               this.monthbdds = JSON.parse(month);
               if(this.monthbdds.length>0){
                 this.months = [];
                 for (let hs of this.monthsFilter) {
                   if (this.monthbdds.indexOf( hs ) != -1) {
                     this.months.push(hs);
                   }
                 }
                 this.monthbddsGet = '';
                 for (let bdds of this.monthbdds) {
                   this.monthbddsGet = this.monthbddsGet+';'+bdds;
                 }
               }
             }else{
               this.monthbddsGet = '';
             }*/
             let org = localStorage.getItem('VUE_TABS_BDDSPF_ORG');
             if (org) {
                 this.IdOrg = JSON.parse(org);
             }
             let house = localStorage.getItem('VUE_TABS_BDDSPF_HOUSE');
             if (house) {
                 this.IdHouse = JSON.parse(house);
             }
         },
         saveFilters: function() {
             localStorage.setItem('VUE_TABS_BDDSPF_YEAR', JSON.stringify(this.yearbdds));
             localStorage.setItem('VUE_TABS_BDDSPF_MONTH', JSON.stringify(this.monthbdds));
             localStorage.setItem('VUE_TABS_BDDSPF_ORG', JSON.stringify(this.IdOrg));
             localStorage.setItem('VUE_TABS_BDDSPF_HOUSE', JSON.stringify(this.IdHouse));
             let month = localStorage.getItem('VUE_TABS_BDDSPF_MONTH');
             if (month) {
               this.monthbdds = JSON.parse(month);
               if(this.monthbdds.length>0){
                 this.months = [];
                 for (let hs of this.monthsFilter) {
                   if (this.monthbdds.indexOf( hs ) != -1) {
                     this.months.push(hs);
                   }
                 }
                 this.monthbddsGet = '';
                 for (let bdds of this.monthbdds) {
                   this.monthbddsGet = this.monthbddsGet+';'+bdds;
                 }
               }else{
                 this.months = this.monthsFilter;
                 this.monthbddsGet = '';
               }
             }else{
               this.monthbddsGet = '';
             }
         },
         changeYearHandle() {
             this.saveFilters();
             this.updateClick();
         },
         changeOrg() {
             this.$store.dispatch('GET_ORGFILTERS', {IdOrg: this.IdOrg, IdHouse: this.IdHouse > 0 ? this.IdHouse : -1}).then(() => {
                 this.updateClick();
             });
             this.saveFilters();
         },
         changeHouse() {
             if (this.IdHouse > 0) {
                 if (this.$store.getters.ORGFILTERS) {
                     this.$store.getters.ORGFILTERS.houselist.forEach((item) => {
                         if (item.ID == this.IdHouse) {
                             this.IdOrg = item.IdTsj;
                             return false;
                         }
                     });
                 }
             }
             this.saveFilters();
             this.updateClick();
         },
         updateClick() {
             //this.expand = [{expand: false, ID: 'in'}];
             //this.expandOut = [{expand: false, ID: 'out'}];
             this.$store.dispatch('GET_BDDSPFLIST', {year: this.yearbdds, month: this.monthbddsGet, IdOrg: this.IdOrg, IdHouse: this.IdHouse}).then(() => {
                 if (this.IdHouse < 1) {
                     this.switchTarif = false;
                 }
             });
         },
         switchTarifClick() {
             this.updateClick();
         },
         endColor(Val) {
             return Val > 0 ? "black--text" : "red--text";
         },
         refreshHandler() {
             this.updateClick();
         },
         onResize() {
             //this.heightTable = (window.innerHeight - this.$refs.bddsplanfactcontainer.clientHeight - 125);
         },
         excelPFList(){
           this.$store.dispatch('EXCEL_BDDSPFLIST', {year: this.yearbdds, month: this.monthbddsGet, IdOrg: this.IdOrg, IdHouse: this.IdHouse}).then(response => {
             window.open(response.data);
           });
         },
         ShowId(id){
           let ret = false;
           this.expand.forEach((item) => {
             if(item.ID == id)
               ret = item.expand;
           });
           this.expandOut.forEach((item) => {
             if(item.ID == id)
               ret = item.expand;
           });
           return ret;
         },
         clickShow(id){
           this.expand.forEach((item) => {
             if(item.ID == id){
               if(item.expand)
                 item.expand = false;
               else
                 item.expand = true;
             }
           });
           this.expandOut.forEach((item) => {
             if(item.ID == id){
               if(item.expand)
                 item.expand = false;
               else
                 item.expand = true;
             }
           });
         },
         iconExpand(id){
           let ret = 'mdi-plus-box-outline';
           this.expand.forEach((item) => {
             if(item.ID == id && item.expand)
               ret = 'mdi-minus-box-outline';
           });
           this.expandOut.forEach((item) => {
             if(item.ID == id && item.expand)
               ret = 'mdi-minus-box-outline';
           });
           return ret;
         }
     },
     computed: {
         yearfilter() {
             let nowYear = new Date().getFullYear() + 1;
             let years = [];
             for (let i = 0; i < 5; i++) {
                 years.push(nowYear - i);
             }
             return years;
         },
         bddsIn() {
           if(this.$store.getters.BDDSPFLIST){
             this.$store.getters.BDDSPFLIST.datain.forEach((item) => {
               let exp = true;
               for (let Out of this.expand){
                 if(Out.ID == item.ID)
                   exp = false;
               }
               if(exp)
                this.expand.push({expand: false, ID: item.ID});
               if(item.sub.length>0){
                 item.sub.forEach((sub) => {
                   let exp = true;
                   for (let Out of this.expand){
                     if(Out.ID == sub.ID)
                       exp = false;
                   }
                   if(exp)
                    this.expand.push({expand: false, ID: sub.ID});
                 });
               }
             });
           }
           return this.$store.getters.BDDSPFLIST ? this.$store.getters.BDDSPFLIST.datain : [];
         },
         bddsOut() {
           if(this.$store.getters.BDDSPFLIST){
             this.$store.getters.BDDSPFLIST.dataout.forEach((item) => {
               let exp = true;
               for (let Out of this.expandOut){
                 if(Out.ID == item.ID)
                   exp = false;
               }
               if(exp)
                this.expandOut.push({expand: false, ID: item.ID});
               if(item.sub.length>0){
                 item.sub.forEach((sub) => {
                   let exp = true;
                   for (let Out of this.expandOut){
                     if(Out.ID == sub.ID)
                       exp = false;
                   }
                   if(exp)
                    this.expandOut.push({expand: false, ID: sub.ID});
                 });
               }
             });
           }
           return this.$store.getters.BDDSPFLIST ? this.$store.getters.BDDSPFLIST.dataout : [];
         },
         In() {
           return this.$store.getters.BDDSPFLIST ? this.$store.getters.BDDSPFLIST.arIn : [];
         },
         Out() {
           return this.$store.getters.BDDSPFLIST ? this.$store.getters.BDDSPFLIST.arOut : [];
         },
         bddsBegOst() {
             return this.$store.getters.BDDSPFLIST ? this.$store.getters.BDDSPFLIST.databegost : [];
         },
         bddsEndOst() {
             return this.$store.getters.BDDSPFLIST ? this.$store.getters.BDDSPFLIST.dataendost : [];
         },
         houselist() {
             let ret = [{text: 'Все', value: -1}];
             if (this.$store.getters.ORGFILTERS) {
                 this.$store.getters.ORGFILTERS.houselist.forEach((item) => {
                     if (this.IdOrg == '' || (this.IdOrg > 0 && item.IdTsj == this.IdOrg)) {
                         ret.push({text: item.Name, value: item.ID});
                     }
                 });
             }
             return ret;
         },
         orglist() {
             let ret = [];
             if (this.$store.getters.ORGFILTERS) {
               if(localStorage.getItem('idtsg')>0){
                 this.$store.getters.ORGFILTERS.orglist.forEach((item) => {
                   if(item.ID == localStorage.getItem('idtsg'))
                     ret.push({text: item.Name, value: item.ID});
                 });
               }else{
                 this.$store.getters.ORGFILTERS.orglist.forEach((item) => {
                   ret.push({text: item.Name, value: item.ID});
                 });
               }
             }
             return ret;
         }
     },
     filters: {
         toCurrency: function (value) {
             if (value === undefined) value = 0;
             let formatter = new Intl.NumberFormat('ru-RU', {maximumFractionDigits: 2});
             return formatter.format(value/1);
         }
     },
 }
</script>

<style scoped>
 .tabcontent {
     padding-top: 35px;
 }
 .rightExPd button{
   margin: 0px 5px;
 }

</style>